<div class="tx-footer">
  <span class="tx-footer-status">{{ status }}</span>

  <!-- The period's movement only. Opening and closing were running totals from the first
       imported transaction, not the bank's balance, so they read as figures they are not. -->
  <div class="tx-footer-figures" *ngIf="mode === 'statement'">
    <span>Money out <b>{{ money(totals.moneyOut) }}</b></span>
    <span>Money in <b class="tx-in">{{ money(totals.moneyIn) }}</b></span>
  </div>

  <div class="tx-footer-figures" *ngIf="mode === 'report'">
    <span>Coded <b>{{ codedCount }} of {{ totalCount }}</b></span>
    <span>Money out <b>{{ money(totals.moneyOut) }}</b></span>
    <span>Money in <b class="tx-in">{{ money(totals.moneyIn) }}</b></span>
  </div>
</div>
